import mapSliceToComponent from '~/imports/category_page'

import { SliceManager } from '@unlikelystudio/react-abstract-components'

import { PageViewAnalytics } from '~/components/PageViewAnalytics'
import PageWithFiltersWrapper from '~/components/PageWithFilters'
import HeroCategory from '~/components/UI/HeroCategory'

import { CategoryPageData } from '~/data/category-page-data'
import getNewInPageStaticPropsFunction from '~/data/new-in-page-data'

export default function NewInPage({
  slices,
  heroData,
  ...props
}: CategoryPageData) {
  return (
    <>
      <HeroCategory {...heroData} />
      <PageWithFiltersWrapper {...props}>
        <SliceManager
          mapSliceTypeToComponent={mapSliceToComponent}
          slicesData={slices}
        />
      </PageWithFiltersWrapper>
      <PageViewAnalytics template="page" />
    </>
  )
}

export const getStaticProps = getNewInPageStaticPropsFunction()
